import { createRoot } from 'react-dom/client';

import App from './App';

import './index.css';
import { reportClientError } from '@/lib/report-error';

// Catch errors that escape React (event handlers, async, etc.) so they're
// reported too, not just render errors caught by the ErrorBoundary.
window.addEventListener('error', event => {
  reportClientError(event.error ?? event.message, 'window.onerror');
});
window.addEventListener('unhandledrejection', event => {
  reportClientError(event.reason, 'unhandledrejection');
});

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element not found');
}
createRoot(rootElement).render(<App />);
